module.exports = __webpack_public_path__ + "img/img-parley-d.a882f1c1.png";